import { useNavigate, useParams } from "react-router";
import { useEffect, useState } from "react";
import restaurantsData from "../data/restaurants.json";
import tablesData from "../data/tables.json";
import { useApp } from "../Context";
import { fetchZones, validateTable } from "../api/apis";

export default function TablePromptPage() {
    const navigate = useNavigate();
    const { restaurant } = useParams();
    const { table: contextTable, setTable, getCfg, setMenu } = useApp();
    const [showInput, setShowInput] = useState(false);

    const [validRestaurant, setValidRestaurant] = useState(false);
    const [tableList, setTableList] = useState([]);
    const [tableNumber, setTableNumber] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
  const tryValidate = async () => {
      const {forceURL = false} = await fetchZones()
      setShowInput(!forceURL)
    const pathname = window.location.pathname;
    const rawHash = window.location.hash.replace("#", "").trim();
    const isRootPath = !pathname.includes("/order");
    const initialTable = isRootPath && rawHash ? rawHash : contextTable || "";

    if (!initialTable) {
      setLoading(false);
      return;
    }

    const { valid, menus, closed } = await validateTable(initialTable);
    if (valid) {
      setMenu(menus);
      setTable(initialTable);
      navigate(`/${restaurant}/order`);
      //navigate(0);
    } else {
      setLoading(false);
    }
  };

  tryValidate();
}, [restaurant]);

const handleTableSubmit = async (manualInput) => {
  const entered = manualInput || tableNumber.trim();
  if (!entered) return setError("Ange ett bordsnummer.");

  setLoading(true);
  const { valid, menus, closed } = await validateTable(entered);
  if(closed){
      setError("Restaurangen är stängd")
      setLoading(false);
      return
  }
  if (!valid) {
    setError("Bordet finns inte.");
    setLoading(false);
    return;
  }

  setMenu(menus);
  await setTable(entered);
  navigate(`/${restaurant}/order`);
  navigate(0);
};


    if (loading) {
        return (
            <div className="text-center mt-5">
                <div className="spinner-border text-primary" />
                <h3>Laddar...</h3>
            </div>
        );
    }
    {/*
        if (!validRestaurant) {
            return (
                <div className="container text-center mt-5">
                    <h2 className="fw-bold text-danger">Restaurang hittades inte</h2>
                    <p className="text-muted">Restaurangen du sökte efter finns inte i vårt system.</p>
                    <button className="btn btn-primary fw-semibold text-dark mt-4 px-4 py-2" onClick={() => navigate("/")}>
                        Till startsidan
                    </button>
                </div>
            );
        }
        */
    }

    return (
        <div className="container text-center mt-5 BackgroundText">
            <h2 className="fw-bold">Skanna QR-koden</h2>
            <p className="">Skanna QR-koden på ditt bord för att komma igång.</p>
            {showInput &&
                <>
            <div className="my-4 fw-semibold text-uppercase">eller</div>
            <p className="mb-3">Ange ditt bordsnummer manuellt nedan:</p>

            <div className="d-flex justify-content-center align-items-center gap-2">
                <input
                    type="text"
                    className={`form-control text-center fw-semibold ${error ? "border-danger" : "border-secondary"} shadow-sm`}
                    style={{ maxWidth: "200px", padding: "10px", fontSize: "1rem" }}
                    placeholder="Bordsnummer"
                    value={tableNumber}
                    onChange={(e) => {
                        setTableNumber(e.target.value);
                        setError("");
                    }}
                    onKeyDown={(e) => e.key === "Enter" && handleTableSubmit()}
                    disabled={loading}
                />
                <button
                    className="btn btn-primary primaryText fw-semibold px-4 py-2 shadow-sm"
                    onClick={() => handleTableSubmit()}
                    disabled={loading}
                >
                    {loading ? (
                        <div className="spinner-border spinner-border-sm text-dark" role="status">
                            <span className="visually-hidden">Laddar...</span>
                        </div>
                    ) : (
                        "Fortsätt"
                    )}
                </button>
            </div>
                </>
}

            {error && <p className="text-danger mt-3 fw-semibold">{error}</p>}
        </div>
    );
}
